<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>
<style>
	body{
		font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica,
			Segoe UI, Arial, Roboto, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft Yahei',
			sans-serif;
			color: #646566;
			font-size: 16px;
			background-color: #f5f6fa;
	}
  .cardzdy{
	  width: 97%;
	  padding: 10px;
	  background-color: #fff;
	  box-shadow: 0px 1px 9px 0px rgba(179,179,179,0.26);
	  border-radius: 6px;
	  margin: 10px auto;
	  overflow: hidden;
	}
	.cardTitle{
		border-bottom: 1px solid rgba(179,179,179,0.26);
		padding-bottom: 10px;
	}
	.titleTxt{
		color: #333;
		border-left: 5px solid #409EFF;
		padding-left:10px ;
		display: inline-block;
		font-weight: 600;
	}
</style>





// WEBPACK FOOTER //
// src/App.vue